import { FileModel, MediaTypeEnum } from '@osos/shared/types';

export function getFileType(file: File): MediaTypeEnum {
  return file.type.split('/')[0] as MediaTypeEnum;
}

export function isVideoFile(file: File): boolean {
  return getFileType(file) === MediaTypeEnum.Video;
}

export function isImageFile(file: File): boolean {
  return getFileType(file) === MediaTypeEnum.Image;
}

export function isFileModel(model: any): model is FileModel {
  return model?.mimeType !== undefined && model?.mimeType !== null;
}

const fileTypes = {
  [MediaTypeEnum.Image]: {
    extensions: ['jpeg', 'jpg', 'png', 'gif', 'webp'],
    mimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  },
  [MediaTypeEnum.Video]: {
    extensions: ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'flv', 'webm'],
    mimeTypes: [
      'video/mp4',
      'video/quicktime',
      'video/x-ms-wmv',
      'video/x-msvideo',
      'video/x-matroska',
      'video/x-flv',
      'video/webm',
    ],
  },
  [MediaTypeEnum.Txt]: {
    extensions: ['txt'],
    mimeTypes: ['text/plain'],
  },
  [MediaTypeEnum.Word]: {
    extensions: ['doc', 'docx'],
    mimeTypes: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  [MediaTypeEnum.Excel]: {
    extensions: ['xls', 'xlsx'],
    mimeTypes: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
  },
  [MediaTypeEnum.PowerPoint]: {
    extensions: ['ppt', 'pptx'],
    mimeTypes: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
  },
  [MediaTypeEnum.Pdf]: {
    extensions: ['pdf'],
    mimeTypes: ['application/pdf'],
  },
};
export function getFileMediaType(file: FileModel): MediaTypeEnum {
  const availableTypes = Object.keys(fileTypes);
  for (const availableType of availableTypes) {
    if (fileTypes[availableType].mimeTypes.includes(file.mimeType)) {
      return availableType as MediaTypeEnum;
    }
    if (
      fileTypes[availableType].extensions.includes(getFileExtension(file.name))
    ) {
      return availableType as MediaTypeEnum;
    }
  }
  return MediaTypeEnum.Other;
}

function getFileExtension(fileName) {
  const parts = fileName.split('.');
  return parts[parts.length - 1];
}
